export default "__VITE_ASSET__D3rWXwY2__"